import { render, staticRenderFns } from "./process-true-hazard-event-modal.vue?vue&type=template&id=405da0b4"
import script from "./process-true-hazard-event-modal.vue?vue&type=script&lang=js"
export * from "./process-true-hazard-event-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports